import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaPropinasLayer from "../components/ListaPropinasLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaPropinasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("propina.breadcrumb.list")} />
      <ListaPropinasLayer />
    </MasterLayout>
  );
};

export default ListaPropinasPage;
